/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Holdout,
    HoldoutFromJSON,
    HoldoutToJSON,
    HoldoutMap,
    HoldoutMapFromJSON,
    HoldoutMapToJSON,
    HoldoutRequestBody,
    HoldoutRequestBodyFromJSON,
    HoldoutRequestBodyToJSON,
    Holdouts,
    HoldoutsFromJSON,
    HoldoutsToJSON,
    PatchRequestBody,
    PatchRequestBodyFromJSON,
    PatchRequestBodyToJSON,
    ProblemDetail,
    ProblemDetailFromJSON,
    ProblemDetailToJSON,
} from '../models';

export interface CreateHoldoutRequest {
    project_id: number;
    holdout_request_body: HoldoutRequestBody;
}

export interface DeleteHoldoutRequest {
    project_id: number;
    holdout_id: number;
}

export interface FetchHoldoutRequest {
    project_id: number;
    holdout_id: number;
}

export interface ListHoldoutsRequest {
    project_id: number;
    archived?: boolean;
    query?: string;
    sort?: Array<ListHoldoutsSortEnum>;
}

export interface UpdateHoldoutsRequest {
    project_id: number;
    holdout_id: number;
    patch_request_body: Array<PatchRequestBody>;
}

/**
 * no description
 */
export class HoldoutsApi extends runtime.BaseAPI {

    /**
     * (Note: This API endpoint in currently development, and not yet ready for public use.)   Creates a new Holdout in a Project.  This operation corresponds to the `create_url` in a Holdouts response.  Required properties must be present in the request body. 
     * Create a new Holdout
     */
    async createHoldoutRaw(requestParameters: CreateHoldoutRequest): Promise<runtime.ApiResponse<Holdout>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling createHoldout.');
        }

        if (requestParameters.holdout_request_body === null || requestParameters.holdout_request_body === undefined) {
            throw new runtime.RequiredError('holdout_request_body','Required parameter requestParameters.holdout_request_body was null or undefined when calling createHoldout.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/holdouts`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HoldoutRequestBodyToJSON(requestParameters.holdout_request_body),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => HoldoutFromJSON(jsonValue));
    }

    /**
     * (Note: This API endpoint in currently development, and not yet ready for public use.)   Creates a new Holdout in a Project.  This operation corresponds to the `create_url` in a Holdouts response.  Required properties must be present in the request body. 
     * Create a new Holdout
     */
    async createHoldout(requestParameters: CreateHoldoutRequest): Promise<Holdout> {
        const response = await this.createHoldoutRaw(requestParameters);
        return await response.value();
    }

    /**
     * Permanently delete a Holdout by id.  There will be no way to access this data after deletion. If you want to stop seeing a Holdout without deleting it permanently, try archiving instead. 
     * Delete a Holdout
     */
    async deleteHoldoutRaw(requestParameters: DeleteHoldoutRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling deleteHoldout.');
        }

        if (requestParameters.holdout_id === null || requestParameters.holdout_id === undefined) {
            throw new runtime.RequiredError('holdout_id','Required parameter requestParameters.holdout_id was null or undefined when calling deleteHoldout.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/holdouts/{holdout_id}`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"holdout_id"}}`, encodeURIComponent(String(requestParameters.holdout_id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Permanently delete a Holdout by id.  There will be no way to access this data after deletion. If you want to stop seeing a Holdout without deleting it permanently, try archiving instead. 
     * Delete a Holdout
     */
    async deleteHoldout(requestParameters: DeleteHoldoutRequest): Promise<void> {
        await this.deleteHoldoutRaw(requestParameters);
    }

    /**
     * (Note: This API endpoint in currently development, and not yet ready for public use.)  Fetch a single holdout by its id.  This operation corresponds to the `fetch_holdout_url` in a Holdout response. 
     * Fetch a single Holdout
     */
    async fetchHoldoutRaw(requestParameters: FetchHoldoutRequest): Promise<runtime.ApiResponse<Holdout>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling fetchHoldout.');
        }

        if (requestParameters.holdout_id === null || requestParameters.holdout_id === undefined) {
            throw new runtime.RequiredError('holdout_id','Required parameter requestParameters.holdout_id was null or undefined when calling fetchHoldout.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/holdouts/{holdout_id}`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"holdout_id"}}`, encodeURIComponent(String(requestParameters.holdout_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => HoldoutFromJSON(jsonValue));
    }

    /**
     * (Note: This API endpoint in currently development, and not yet ready for public use.)  Fetch a single holdout by its id.  This operation corresponds to the `fetch_holdout_url` in a Holdout response. 
     * Fetch a single Holdout
     */
    async fetchHoldout(requestParameters: FetchHoldoutRequest): Promise<Holdout> {
        const response = await this.fetchHoldoutRaw(requestParameters);
        return await response.value();
    }

    /**
     * (Note: This API endpoint in currently development, and not yet ready for public use.)  Create, update, or archive a Holdout in a Project. 
     * List Holdouts for a project
     */
    async listHoldoutsRaw(requestParameters: ListHoldoutsRequest): Promise<runtime.ApiResponse<Holdouts>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling listHoldouts.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.archived !== undefined) {
            queryParameters['archived'] = requestParameters.archived;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/holdouts`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => HoldoutsFromJSON(jsonValue));
    }

    /**
     * (Note: This API endpoint in currently development, and not yet ready for public use.)  Create, update, or archive a Holdout in a Project. 
     * List Holdouts for a project
     */
    async listHoldouts(requestParameters: ListHoldoutsRequest): Promise<Holdouts> {
        const response = await this.listHoldoutsRaw(requestParameters);
        return await response.value();
    }

    /**
     * (Note: This API endpoint in currently development, and not yet ready for public use.)  Update one or more Holdouts in a project using a json patch structure.  Properties that are readOnly that are present in the request body will be ignored as well as unknown properties. 
     * Update Holdouts
     */
    async updateHoldoutsRaw(requestParameters: UpdateHoldoutsRequest): Promise<runtime.ApiResponse<HoldoutMap>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling updateHoldouts.');
        }

        if (requestParameters.holdout_id === null || requestParameters.holdout_id === undefined) {
            throw new runtime.RequiredError('holdout_id','Required parameter requestParameters.holdout_id was null or undefined when calling updateHoldouts.');
        }

        if (requestParameters.patch_request_body === null || requestParameters.patch_request_body === undefined) {
            throw new runtime.RequiredError('patch_request_body','Required parameter requestParameters.patch_request_body was null or undefined when calling updateHoldouts.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/projects/{project_id}/holdouts/{holdout_id}`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"holdout_id"}}`, encodeURIComponent(String(requestParameters.holdout_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patch_request_body.map(PatchRequestBodyToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => HoldoutMapFromJSON(jsonValue));
    }

    /**
     * (Note: This API endpoint in currently development, and not yet ready for public use.)  Update one or more Holdouts in a project using a json patch structure.  Properties that are readOnly that are present in the request body will be ignored as well as unknown properties. 
     * Update Holdouts
     */
    async updateHoldouts(requestParameters: UpdateHoldoutsRequest): Promise<HoldoutMap> {
        const response = await this.updateHoldoutsRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListHoldoutsSortEnum {
    Nameasc = 'name:asc',
    Namedesc = 'name:desc',
    Keyasc = 'key:asc',
    Keydesc = 'key:desc',
    CreatedTimeasc = 'created_time:asc',
    CreatedTimedesc = 'created_time:desc',
    Statusasc = 'status:asc',
    Statusdesc = 'status:desc'
}
